var map = {
	"./Apt.svg": "0474",
	"./Brick.svg": "c2aa",
	"./Liza.svg": "8585",
	"./Roof.svg": "c1db",
	"./Stairs.svg": "8ddc",
	"./Wonder.svg": "6501",
	"./Younger.svg": "5523"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f10e";